import { Star, Quote } from "lucide-react";
import { FadeUp, SectionHeading } from "./Reveal";

const REVIEWS = [
  {
    name: "Jerod Stinnett",
    text: "Grant and his crew lifted my Tacoma to replace worn out factory parts. Truck rides and drives great. Easy to work with and do quality work. Can't recommend them enough.",
  },
  {
    name: "Willie Tello",
    text: "Grant and crew did a great job getting me set up for the complete weight-loss on my 2020 Ram 3500 6.7 Cummins. Looking forward to them adding rock lights on my wife's 2013 Jeep Rubicon.",
  },
  {
    name: "Tucker Berkley",
    text: "This guy gives his all in every project. Made my Chevy look amazing.",
  },
  {
    name: "Andrew Eubanks",
    text: "Great guys and take pride in work.",
  },
];

export const Reviews = () => (
  <section className="mx-auto max-w-7xl px-4 sm:px-8 pb-24 sm:pb-36" data-testid="reviews-section">
    <SectionHeading
      eyebrow="Facebook Reviews"
      title={<>Word from<br /><span className="text-outline-volt">the lot</span></>}
      className="mb-14"
    />
    <div className="grid grid-cols-1 sm:grid-cols-2 gap-5">
      {REVIEWS.map((r, i) => (
        <FadeUp key={r.name} delay={i * 0.08}>
          <figure
            data-testid={`review-card-${i}`}
            className="clip-corner group relative h-full border border-zinc-800 bg-carbon p-7 sm:p-9 transition-colors duration-500 hover:border-volt/50"
          >
            <Quote className="absolute right-6 top-6 text-bolt/25 transition-colors duration-500 group-hover:text-bolt/50" size={48} fill="currentColor" strokeWidth={0} />
            <div className="mb-5 flex gap-1" aria-label="5 out of 5 stars">
              {[...Array(5)].map((_, s) => (
                <Star key={s} size={15} className="text-volt" fill="currentColor" strokeWidth={0} />
              ))}
            </div>
            <blockquote className="text-base sm:text-lg leading-relaxed text-zinc-200 mb-7">
              &ldquo;{r.text}&rdquo;
            </blockquote>
            <figcaption>
              <p className="font-display text-xl font-bold uppercase italic tracking-tight text-white">{r.name}</p>
              <p className="mt-1 font-mono text-[10px] font-bold uppercase tracking-[0.25em] text-zinc-500">
                Facebook review
              </p>
            </figcaption>
          </figure>
        </FadeUp>
      ))}
    </div>
  </section>
);
